/* ONECART スキャンショップ優先表示（2026-06-30）
   店舗QR（assist）→ ログイン顧客に紐づいたショップを、アカウント基準（端末非依存）で優先表示する。
   - home(#oc-scan-shops)：対象ショップの「新着商品」エリアを最大3つ（各6商品＋一覧リンク）。
   - ドロワー([data-drawer-scan="shops"])：対象ショップ一覧 → /pages/shop/<slug>（hero＋クーポンのショップページ）。
   データ源＝assist API①（後日）：GET <apiBase>/promotion/scan/web/my-shops?user_id=<customer.id>
     → { code:0, data:[ { shop_slug, name } ... ] }（最大3・新しい順）。
   ★未ログインは出さない（アカウント基準）。API①未実装の間は空＝非表示のまま（非侵襲）。
   テスト注入：?ocscan=slug:Name,slug2:Name2 （customer/API を介さず描画確認用）。 */
(function () {
  'use strict';

  // 為你推薦（oc-personal）の「最近瀏覧」からスキャン店を除外するための共有シグナル。
  // 解決値＝スキャン表示した店の /pages/shop/<slug> URL 配列（未ログイン/未紐付けは []）。
  var _scanResolve;
  window.OC_SCAN_READY = new Promise(function (res) { _scanResolve = res; });

  var MAX_AREAS = 3;
  var PER = 6;                 // 各エリア6商品（仕様）
  var DEFAULT_API = 'https://assist.onecart.jp/api';

  function cfg() {
    // 設定はドロワーの scan 枠 or home 枠の data 属性から拾う（グローバル稼働）。
    var d = document.querySelector('[data-drawer-scan="shops"]') || document.getElementById('oc-scan-shops');
    return {
      apiBase: (d && d.getAttribute('data-api-base')) || DEFAULT_API,
      titleSuffix: (document.getElementById('oc-scan-shops') || {}).dataset
        ? (document.getElementById('oc-scan-shops').dataset.titleSuffix || '') : ''
    };
  }

  function customerInfo() {
    var el = document.getElementById('oc-scan-customer');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function testOverride() {
    var raw = new URLSearchParams(location.search).get('ocscan');
    if (!raw) return null;
    return raw.split(',').map(function (s) {
      var p = s.split(':');
      return { slug: (p[0] || '').trim(), name: (p.slice(1).join(':') || p[0] || '').trim() };
    }).filter(function (x) { return x.slug; }).slice(0, MAX_AREAS);
  }

  function fetchScanShops(apiBase, cb) {
    var ov = testOverride();
    if (ov) { cb(ov); return; }
    var c = customerInfo();
    if (!c || !c.id) { cb([]); return; }   // アカウント基準：未ログインは対象外
    fetch(apiBase + '/promotion/scan/web/my-shops?user_id=' + encodeURIComponent(c.id),
          { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.code === 0 && Array.isArray(d.data)) ? d.data : [];
        cb(list.map(function (x) {
          return { slug: x.shop_slug || x.slug, name: x.name || x.shop_name || x.shop_slug || x.slug };
        }).filter(function (x) { return x.slug; }).slice(0, MAX_AREAS));
      })
      .catch(function () { cb([]); });
  }

  // section-render から実カードを n 枚抽出（oc-personal と同方式）。
  function fetchCards(url, n) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice
          .call(doc.querySelectorAll('.oc-card:not([aria-hidden="true"])'))
          .slice(0, n);
      })
      .catch(function () { return []; });
  }

  // /pages/shop/<slug> の新着順（created-descending）。slug だけで取得可。
  function shopNewArrivalsUrl(slug) {
    return '/pages/shop/' + encodeURIComponent(slug) +
      '?section_id=shop-products-with-facets&sort_by=created-descending';
  }
  function shopPageUrl(slug) { return '/pages/shop/' + encodeURIComponent(slug); }

  /* ---- home：新着エリア（最大3・各6商品＋一覧リンク）---- */
  function buildHomeAreas(shops, conf) {
    var root = document.getElementById('oc-scan-shops');
    if (!root || !shops.length) return;
    var tpl = document.getElementById('oc-scan-area-tpl');
    if (!tpl) return;
    shops.forEach(function (sh) {
      fetchCards(shopNewArrivalsUrl(sh.slug), PER).then(function (cards) {
        if (!cards.length) return;
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.querySelector('.oc-scan-area__title').textContent = (sh.name || '') + (conf.titleSuffix || '');
        var more = node.querySelector('.oc-scan-area__more');
        if (more) more.href = shopPageUrl(sh.slug);
        var ul = node.querySelector('.oc-scan-area__grid');
        cards.forEach(function (card) {
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.appendChild(document.importNode(card, true));
          ul.appendChild(li);
        });
        root.appendChild(node);
        root.hidden = false;
      });
    });
  }

  /* ---- ドロワー：Shop（スキャンしたショップ）→ hero＋クーポンのショップページ ----
     既存の履歴チップ（.oc-hist-shop）スタイルを流用。 */
  function buildDrawer(shops) {
    var sec = document.querySelector('[data-drawer-scan="shops"]');
    if (!sec || !shops.length) return;
    var row = sec.querySelector('.oc-dh__row');
    if (!row) return;
    row.textContent = '';
    shops.forEach(function (sh) {
      var a = document.createElement('a');
      a.className = 'oc-hist-shop';
      a.href = shopPageUrl(sh.slug);
      var av = document.createElement('span');
      av.className = 'oc-hist-shop__av';
      av.appendChild(document.createTextNode((sh.name || '?').charAt(0).toUpperCase()));
      var nm = document.createElement('span');
      nm.className = 'oc-hist-shop__name';
      nm.textContent = sh.name || '';
      a.appendChild(av);
      a.appendChild(nm);
      row.appendChild(a);
    });
    sec.hidden = false;
  }

  function init() {
    var conf = cfg();
    fetchScanShops(conf.apiBase, function (shops) {
      // oc-personal が「最近瀏覧」からスキャン店を飛ばせるよう url を共有（購入=再次購買は除外しない）。
      if (_scanResolve) _scanResolve(shops.map(function (s) { return '/pages/shop/' + s.slug; }));
      if (!shops.length) return;
      buildHomeAreas(shops, conf);
      buildDrawer(shops);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
